import { CheckCircle } from "lucide-react";
import { Header } from "../ui/header";
export const OrderSuccessHeader = () => {
  const successIcon = (
    <div className="relative">
      <CheckCircle className="w-6 h-6 text-green-500" />
    </div>
  );
  return (
    <Header
      title="Order Confirmed"
      showBackButton={false}
      rightElement={successIcon}
    />
  );
};